const routes = {
  index: {
    path: 'index.consult.search',
    url: '/search',
  },
  home: {
    path: 'index.consult.search.home',
    url: '/accueil',
  },
}

export default routes



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/consult/search/routes.js